import {
    transition
} from "assets/jss/material-dashboard-pro-react.jsx";

export default {
    root: {
        ...transition,
        margin: "10px 10px 25px 10px"
    }
}